/**
 * Custom JavaScript
 *
 * Prevents Lioncrest featured collection quick-buy buttons from redirecting
 * customers to the cart page. Instead, the item is added via AJAX and the
 * customer stays on the current page.
 */

document.addEventListener('submit', function (event) {
  var form = event.target;

  if (!form.matches('.lc-featured-collection form[action*="/cart/add"]')) {
    return;
  }

  event.preventDefault();

  var button = form.querySelector('[type="submit"]');
  var originalButtonText = button ? button.textContent : 'Add to cart';

  if (button) {
    button.disabled = true;
    button.textContent = 'Adding...';
  }

  fetch(window.routes.cartAddUrl + '.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: new FormData(form)
  })
    .then(function (response) {
      if (!response.ok) {
        throw new Error('Cart add failed');
      }

      return response.json();
    })
    .then(function (item) {
      document.documentElement.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: {
          variant: item.variant_id,
          quantity: item.quantity || 1
        }
      }));

      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: {
          scrollToTop: false
        }
      }));

      if (button) {
        button.textContent = 'Added';
      }

      setTimeout(function () {
        if (button) {
          button.disabled = false;
          button.textContent = originalButtonText;
        }
      }, 1800);
    })
    .catch(function () {
      if (button) {
        button.disabled = false;
        button.textContent = originalButtonText;
      }

      alert('Sorry, this item could not be added to cart.');
    });
}, true);